var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "trellis-assets": "static-1.1702"
    },
    "depPathPrefixes": {
      "trellis-assets": "/trellis-assets/static-1.1702"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.33231",
    "project": "trellis-assets",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};